import { StoreResult } from '@/store/CertificateStore';
import { AbstractSignatureStrategy } from './AbstractSignatureStrategy';
import Dictionary from '@/types/Dictionary';
import { Resource, SMACertificate } from '@/types/Administration/SMA/SMACertificate';

export class ImportSignature extends AbstractSignatureStrategy {

    /**
     * Demande de validation par mot de passe
     */
    public readonly requiresPasswordValidation = true;

    /**
     * Récupération du mandat format base
     * @param parameters 
     */
    public override async execute({ item: certificate, resource: resources }: { item: SMACertificate; resource: Resource[] }): Promise<StoreResult<Blob>> {
        return null;
    }

    /**
     * Submit de la signature client
     * @param parameters 
     */
    public override async validation(parameters: Dictionary<any>): Promise<StoreResult<Blob>> {
        return await this.store.dispatch("CertificateStore/ClientValidation", { 
            Certificate: parameters.Certificate,
            Base64File: parameters.Base64File,
            Password: parameters.Password
        });
    }
}